// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BarcodeOutlinedSvg from "@ant-design/icons-svg/es/asn/BarcodeOutlined";
import AntdIcon from '../components/AntdIcon';

var BarcodeOutlined = function BarcodeOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BarcodeOutlinedSvg
  }));
};

BarcodeOutlined.displayName = 'BarcodeOutlined';
export default React.forwardRef(BarcodeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BarcodeOutlined.js
// module id = 625
// module chunks = 0